export const flexThemeToken: any = {};
